import Vue from 'vue'
import Router from 'vue-router'

// 导入 Layout 组件
import Layout from '@/layout/index.vue'

Vue.use(Router)

// --- 解决路由重复跳转报错 (保留你原本的配置) ---
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}

export const routes = [
  // ==========================================================
  // 第一部分：不需要 Layout 的页面 (白名单页面)
  // ==========================================================
  
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login'), // 请确保文件名大小写正确
    hidden: true
  },
  
  // 数据大屏
  {
    path: '/big-screen', 
    name: 'BigScreen',
    component: () => import('@/views/big-screen/index.vue')
  },
  
  // 详情页 (之前你双击跳转的页面)
  {
    path: '/detail',
    name: 'Detail',
    component: () => import('@/views/big-screen/detail.vue')
  },

  // ==========================================================
  // 第二部分：需要 Layout 的页面 (核心业务系统)
  // ==========================================================
  
  {
    path: '/',
    component: Layout,
    redirect: '/database', // 登录后默认跳到第一个菜单
    children: [
      // 1. 数据库 (对应菜单 index="/database")
      {
        path: 'database',
        name: 'Database',
        // 假设你原来的 dashboard 就是这个页面，如果不是请修改路径
        component: () => import('@/views/dashboard/index.vue'), 
        meta: { title: '数据库', icon: 's-home' }
      },

      // 2. 生物多样性 (二级菜单容器)
      {
        path: 'biodiversity',
        name: 'Biodiversity',
        // 【关键点】这里不需要具体的 vue 文件，只需要一个 router-view 容器来渲染子路由
        component: () => import('@/views/biodiversity/index.vue'),
        meta: { title: '生物多样性', icon: 's-data' },
       
      },

      // 3. 生态系统服务 (对应菜单 index="/system")
      {
        path: 'system',
        name: 'SystemService',
        component: { render: (h) => h('router-view') }, 
        meta: { title: '生态系统服务', icon: 's-cooperation' },
        children: [
          {
            path: 'carbon', // 访问路径: /biodiversity/list
            name: 'Carbon',
            // 请确保创建了此文件: src/views/biodiversity/list.vue
            component: () => import('@/views/biodiversity/carbon.vue'),
            meta: { title: '碳储量' }
          },
          {
            path: 'list', // 访问路径: /biodiversity/list
            name: 'BioList',
            // 请确保创建了此文件: src/views/biodiversity/list.vue
            component: () => import('@/views/biodiversity/list.vue'),
            meta: { title: '土壤肥力' }
          },
          {
            path: 'stats', // 访问路径: /biodiversity/stats
            name: 'BioStats',
            // 请确保创建了此文件: src/views/biodiversity/stats.vue
            component: () => import('@/views/biodiversity/stats.vue'),
            meta: { title: '水源涵养' }
          },
          {
            path: 'production', // 访问路径: /biodiversity/stats
            name: 'Production',
            // 请确保创建了此文件: src/views/biodiversity/stats.vue
            component: () => import('@/views/biodiversity/production.vue'),
            meta: { title: '生产能力' }
          },
          {
            path: 'concentration', // 访问路径: /biodiversity/stats
            name: 'Concentration',
            // 请确保创建了此文件: src/views/biodiversity/stats.vue
            component: () => import('@/views/biodiversity/concentration.vue'),
            meta: { title: '负氧离子浓度' }
          },
          {
            path: 'culture', // 访问路径: /biodiversity/stats
            name: 'Culture',
            // 请确保创建了此文件: src/views/biodiversity/stats.vue
            component: () => import('@/views/biodiversity/culture.vue'),
            meta: { title: '文化服务' }
          },
          {
            path: 'summary', // 访问路径: /biodiversity/stats
            name: 'Summary',
            // 请确保创建了此文件: src/views/biodiversity/stats.vue
            component: () => import('@/views/biodiversity/summary.vue'),
            meta: { title: '模块汇总' }
          }
        ]
      },
      {
        path: 'ecology',
        name: 'Ecology',
        component: () => import('@/views/ecology/index.vue'),
        meta: { title: '生态系统服务权衡与协同', icon: 'files' }
      },
      
      // 4. 知识库 (对应菜单 index="/knowledge")
      {
        path: 'knowledge',
        name: 'Knowledge',
        component: () => import('@/views/knowledge/index.vue'),
        meta: { title: '知识库', icon: 'files' }
      },
      {
        path: 'aiQa',
        name: 'AiQa',
        component: () => import('@/views/aiQa/index.vue'),
        meta: { title: 'ai问答', icon: 'files' }
      },
        // 3. 生态系统服务 (对应菜单 index="/system")
        {
          path: 'permission',
          name: 'Permission',
          component: { render: (h) => h('router-view') }, 
          meta: { title: '权限管理', icon: 's-cooperation' },
          children: [
            {
              path: 'account', // 访问路径: /biodiversity/list
              name: 'Account',
              // 请确保创建了此文件: src/views/biodiversity/list.vue
              component: () => import('@/views/permission/account.vue'),
              meta: { title: '账号管理' }
            },
            {
              path: 'role', // 访问路径: /biodiversity/list
              name: 'Role',
              // 请确保创建了此文件: src/views/biodiversity/list.vue
              component: () => import('@/views/permission/role.vue'),
              meta: { title: '角色管理' }
            },
            {
              path: 'list', // 访问路径: /biodiversity/list
              name: 'List',
              // 请确保创建了此文件: src/views/biodiversity/list.vue
              component: () => import('@/views/permission/list.vue'),
              meta: { title: '权限管理' }
            }
          ]
        },

      {
        path: 'article-categories',
        name: 'ArticleCategories',
        component: () => import('@/views/articleCategories/index.vue'),
        meta: { title: '分类管理', icon: 'folder' }
      },
      
      // ... 你可以继续添加其他菜单对应的路由
    ]
  },

  // 404 页面
  {
    path: '/404',
    component: () => import('@/views/error/404.vue'),
    hidden: true
  },
  
  // 兜底路由
  { path: '*', redirect: '/404', hidden: true }
]

const router = new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes
})

export default router